import { Mapping } from 'api/MappingsAPI';
import { AxiosError } from 'axios';
import { createContext, useContext } from 'react';
import noop from 'utils/noop';

export type CustomEventDetailsContextState = {
  isLoadingCustomEventDetails: boolean;
  refetchCustomEventDetails: () => void;
  customEventDetails: Mapping[];
  customEventDetailsError: AxiosError | null;
};

export const initialCustomEventDetailsState: CustomEventDetailsContextState = {
  isLoadingCustomEventDetails: false,
  refetchCustomEventDetails: noop,
  customEventDetails: [],
  customEventDetailsError: null,
};

export const CustomEventDetailsContext = createContext<CustomEventDetailsContextState | undefined>(
  undefined,
);

export const useCustomEventDetailsContext = () => {
  const context = useContext(CustomEventDetailsContext);

  if (context === undefined) {
    throw new Error('useCustomEventDetailsContext must be used within a provider');
  }

  return context;
};
